export enum ProjectStatusModel {
    IN_PROGRESS = 'In Progress',
    CLOSED = 'Closed',
    DEMO_COMPLETED = 'Demo Completed',
    CANCELLED = 'Cancelled',
    DEMO_IN_PROGRESS = 'Demo In Progress'
}